<template>
  <div id="contractDetail">
    <Svge />
    <!-- 详情 -->
    <van-tabs v-model="active" class="tabs" v-if="type == 0">
      <van-tab title="合约详情">
        <div class="title"><i class="iconfont iconbookmark"></i> 基本信息</div>
        <van-cell title="合约编号" :value="contractDetail.contract.number" />
        <van-cell
          title="合约状态"
          :value="contractList[contractDetail.contract.status - 1]"
        />
        <van-cell
          title="合约类型"
          :value="contractTypeList[contractDetail.contract.type - 1]"
        />
        <van-cell
          title="租赁方式"
          :value="contractDetail.contract.rentType == 1 ? '合租' : '整租'"
        />

        <van-cell
          title="是否重签"
          :value="contractDetail.contract.isResign ? '是' : '否'"
        />
        <van-cell
          title="网签状态"
          :value="
            syncFgjNjList[contractDetail.contract.syncFgjNj - 1] || '待推送'
          "
        />
        <van-cell
          title="签署状态"
          :value="contractDetail.contract.caStatus?caStatusList[contractDetail.contract.caStatus - 1]: '未签署'"
        />

        <van-cell
          v-if="contractDetail.existEle"
          title="是否断电"
          :value="contractDetail.contract.autoPowerOff ? '断电' : '不断电'"
        />
        <div class="title"><i class="iconfont iconbookmark"></i> 房源信息</div>
        <van-cell title="房源编码" :value="contractDetail.house.number" />
        <van-cell
          title="地址"
          :value="
            contractDetail.room
              ? contractDetail.house.address + contractDetail.room.no
              : contractDetail.house.address
          "
        />
        <div class="title"><i class="iconfont iconbookmark"></i> 租客信息</div>
        <van-cell title="租客姓名" :value="contractDetail.customer.name" />
        <van-cell title="租客电话" class="space_bet">
          <template #right-icon>
            <a class="tel" :href="'tel:' + contractDetail.customer.phone">
              <van-icon name="phone" class="search-phone" color="#fd7e2d" />
              拨打
            </a>
          </template>
        </van-cell>
        <van-cell
          title="租客类型"
          :value="
            contractDetail.contract.customerType == 1
              ? '个人客户'
              : contractDetail.contract.customerType == 2
              ? '企业客户'
              : ''
          "
        />
        <van-cell
          v-if="
            contractDetail.contract.status >= 1 &&
            contractDetail.contract.status <= 3
          "
          title="证件号码"
          :value="
            '【' +
            idTypeList[contractDetail.customer.idType - 1] +
            '】' +
            contractDetail.customer.idNo
          "
        />
        <van-cell
          title="企业名称"
          v-if="contractDetail.contract.customerType == 2"
          :value="contractDetail.contract.orgName"
        />
        <van-cell
          title="社会信用代码"
          v-if="contractDetail.contract.customerType == 2"
          :value="contractDetail.contract.orgNo"
        />
        <van-cell
          title="电子邮箱"
          :value="contractDetail.customer.email || '-'"
        />
        <van-cell
          title="紧急联系人"
          :value="
            '【' +
            contactList[contractDetail.contract.contactRelation - 1] +
            '】' +
            contractDetail.contract.contactName
          "
        />
        <van-cell title="紧急联系人电话" class="space_bet">
          <template #right-icon>
            <a
              class="tel"
              :href="'tel:' + contractDetail.contract.contactPhone"
            >
              <van-icon name="phone" class="search-phone" color="#fd7e2d" />
              拨打
            </a>
          </template>
        </van-cell>
        <van-cell
          title="工作单位"
          :value="contractDetail.customer.company || '-'"
        />
        <van-cell
          title="职位"
          :value="contractDetail.customer.position || '-'"
        />
        <div class="title"><i class="iconfont iconbookmark"></i> 签约信息</div>
        <van-cell
          title="开始日期"
          :value="
            contractDetail.contract.startDate
              ? contractDetail.contract.startDate.slice(0, 10)
              : ''
          "
        />
        <van-cell
          title="租期"
          :value="
            (contractDetail.contract.leaseMonth
              ? contractDetail.contract.leaseMonth + '月'
              : '') +
            (contractDetail.contract.leaseDay
              ? contractDetail.contract.leaseDay + '天'
              : '')
          "
        />
        <van-cell
          title="结束日期"
          :value="
            contractDetail.contract.endDate
              ? contractDetail.contract.endDate.slice(0, 10)
              : ''
          "
        />
        <van-cell
          title="支付方式"
          :value="
            contractDetail.contract.payMonth == '999'
              ? '全额付'
              : '付' +
                contractDetail.contract.payMonth +
                '押' +
                contractDetail.contract.depositMonth
          "
        />
        <van-cell
          title="租金"
          :value="contractDetail.contract.rental + '元/月' || '-'"
        />

        <van-cell
          v-if="
            contractDetail.contract.activityId &&
            contractDetail.contract.activity
          "
          title="活动价格"
          :value="contractDetail.contract.activityRental + '元/月'"
        />
        <van-cell
          v-if="
            contractDetail.contract.activityId &&
            contractDetail.contract.activity
          "
          title="参加活动"
          :value="
            contractDetail.contract.activityId &&
            contractDetail.contract.activity
              ? `【${contractDetail.contract.activity.typeDesc}】
          ${
            contractDetail.contract.activity.type == 3
              ? ''
              : '【' + contractDetail.contract.activity.ftypeDesc + '】'
          }
          【${contractDetail.contract.activity.name}】`
              : ''
          "
        />
        <van-cell
          title="押金"
          :value="contractDetail.contract.deposit + '元' || '-'"
        />
        <van-cell
          title="定金"
          :value="
            contractDetail.destineContract
              ? contractDetail.destineContract.amount
              : '-'
          "
        />
        <van-cell
          title="水电燃预交费"
          :value="contractDetail.contract.advanceFee + '元/月' || '-'"
        />
        <van-cell
          v-if="contractDetail.existEle || contractDetail.existWater"
          title="智能水电余额"
          :value="contractDetail.contract.deviceBalanceYuan + '元'"
        />
        <van-cell
          title="服务费"
          :value="contractDetail.contract.serviceFee || '-'"
        />
        <van-cell
          title="物业费"
          :value="contractDetail.contract.condoFee + '元/月' || '-'"
        />
        <van-cell title="创建人" :value="contractDetail.contract.creator" />
        <van-cell
          title="创建日期"
          :value="contractDetail.contract.createDate"
        />
        <div class="title">
          <i class="iconfont iconbookmark"></i> 一次性费用
        </div>
        <van-cell
          v-for="item in contractDetail.singleMatterList"
          :key="item.id"
          :title="item.matterName"
          :value="item.amount"
        />
        <div class="title">
          <i class="iconfont iconbookmark"></i> 周期性费用
        </div>
        <van-cell
          v-for="item in contractDetail.periodMatterList"
          :key="item.id"
          :title="item.matterName"
          :value="item.amount"
        />
        <div class="title"><i class="iconfont iconbookmark"></i> 入住人</div>
        <div
          v-for="item in contractDetail.customerPersonList || []"
          :key="item.id"
        >
          <van-cell title="姓名" :value="item.name" />
          <van-cell title="电话" class="space_bet">
            <template #right-icon>
              <a class="tel" :href="'tel:' + item.phone">
                <van-icon name="phone" class="search-phone" color="#fd7e2d" />
                拨打
              </a>
            </template>
          </van-cell>
          <!-- <van-cell
            title="证件号"
            :value="'【' + idTypeList[item.idType - 1] + '】' + item.idCard"
          /> -->
        </div>
      </van-tab>
      <van-tab title="跟进记录">
        <div style="height: 15px; width: 100%"></div>
        <van-steps
          v-if="contractDetail.operateRecord"
          direction="vertical"
          :active="0"
          active-color="#FD7E2D"
          active-icon="more"
          inactive-icon="checked"
        >
          <van-step
            v-for="item in contractDetail.operateRecord || []"
            :key="item.id"
          >
            <h4>{{ `${item.statusName} 【${item.creator}】` }}</h4>
            <p>
              {{ item.content }}
              <!-- <span v-if="item.status == 103">（{{(item.takeLookDate||'').slice(0,16)}}）</span> -->
              <span v-if="item.status == 108">
                （
                <span
                  v-for="(item1, index1) in item.trackRecordReasons"
                  :key="item1.id"
                  >{{ index1 == 0 ? item1.name : "，" + item1.name }}</span
                >）
              </span>
            </p>
            <p v-if="item.remark">{{ item.remark }}</p>
            <p>{{ item.createDate }}</p>
          </van-step>
        </van-steps>
        <van-empty v-else description="暂无数据" />
      </van-tab>
      <van-tab title="资产信息" class="assets">
        <div v-for="item in contractDetail.contractAssetsVOList" :key="item.no">
          <div class="title">
            <i class="iconfont iconbookmark"></i>
            {{ item.no === "Pub" ? "公区" : item.no }}&ensp;
          </div>
          <div class="assetsBody">
            <div
              v-for="assets in item.assets"
              :key="assets.assetsId"
              @click="lookAssets(assets)"
            >
              {{ assets.materialTypeName }}
            </div>
          </div>
        </div>
        <van-empty
          v-if="!contractDetail.contractAssetsVOList.length"
          description="暂无数据"
        />
      </van-tab>
      <van-tab title="附件信息">
        <div
          v-if="
            contractDetail.contract.status >= 1 &&
            contractDetail.contract.status <= 3
          "
        >
          <div class="title">
            <i class="iconfont iconbookmark"></i>
            签约人证件照&ensp;
          </div>
          <div class="imgBody">
            <div class="imgCard">
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [
                    contractDetail.contractImage.contractorFront +
                      `${isAddTextMask ? imgMaskUrl : ''}`,
                  ];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="
                    contractDetail.contractImage.contractorFront +
                    `${isAddTextMask ? imgMaskUrl : ''}`
                  "
                />
              </div>
              <div class="text">正面</div>
            </div>
            <div class="imgCard">
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [
                    contractDetail.contractImage.contractorBack +
                      `${isAddTextMask ? imgMaskUrl : ''}`,
                  ];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="
                    contractDetail.contractImage.contractorBack +
                    `${isAddTextMask ? imgMaskUrl : ''}`
                  "
                />
              </div>
              <div class="text">反面</div>
            </div>
            <div
              class="imgCard"
              v-if="contractDetail.contract.customerType == 2"
            >
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [contractDetail.contractImage.businessLicense];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="contractDetail.contractImage.businessLicense"
                />
              </div>
              <div class="text">营业执照</div>
            </div>
          </div>
        </div>
        <div
          v-if="
            contractDetail.contract.status >= 1 &&
            contractDetail.contract.status <= 3
          "
        >
          <div
            v-for="(item, index) in contractDetail.customerPersonList"
            :key="index"
          >
            <div class="title">
              <i class="iconfont iconbookmark"></i>
              入住人{{ index + 1 }}证件照&ensp;
            </div>
            <div class="imgBody">
              <div class="imgCard">
                <div
                  class="img"
                  @click="
                    imgShow = true;
                    imgIndex = 0;
                    images = [
                      item.frontCertificateUrl +
                        `${isAddTextMask ? imgMaskUrl : ''}`,
                    ];
                  "
                >
                  <van-image
                    width="3rem"
                    height="3rem"
                    :src="
                      item.frontCertificateUrl +
                      `${isAddTextMask ? imgMaskUrl : ''}`
                    "
                  />
                </div>
                <div class="text">正面</div>
              </div>
              <div class="imgCard">
                <div
                  class="img"
                  @click="
                    imgShow = true;
                    imgIndex = 0;
                    images = [
                      item.backCertificateUrl +
                        `${isAddTextMask ? imgMaskUrl : ''}`,
                    ];
                  "
                >
                  <van-image
                    width="3rem"
                    height="3rem"
                    :src="
                      item.backCertificateUrl +
                      `${isAddTextMask ? imgMaskUrl : ''}`
                    "
                  />
                </div>
                <div class="text">反面</div>
              </div>
              <div class="imgCard" style="width: 3rem"></div>
            </div>
          </div>
        </div>
        <div>
          <div class="title">
            <i class="iconfont iconbookmark"></i>
            电度数&ensp;
          </div>
          <div class="imgBody imgBody1">
            <div class="imgCard">
              <div class="text">电峰</div>
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [contractDetail.contractImage.electricMax];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="contractDetail.contractImage.electricMax"
                />
              </div>
              <div class="text">{{ contractDetail.contract.electricMax }}</div>
            </div>
            <div class="imgCard">
              <div class="text">电谷</div>
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [contractDetail.contractImage.electricMin];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="contractDetail.contractImage.electricMin"
                />
              </div>
              <div class="text">{{ contractDetail.contract.electricMin }}</div>
            </div>
            <div class="imgCard">
              <div class="text">电总</div>
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [contractDetail.contractImage.electricTotal];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="contractDetail.contractImage.electricTotal"
                />
              </div>
              <div class="text">
                {{ contractDetail.contract.electricTotal }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="title">
            <i class="iconfont iconbookmark"></i>
            水度数&ensp;
          </div>
          <div class="imgBody">
            <div class="imgCard">
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [contractDetail.contractImage.water];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="contractDetail.contractImage.water"
                />
              </div>
              <div class="text">{{ contractDetail.contract.water }}</div>
            </div>
          </div>
        </div>
        <div>
          <div class="title">
            <i class="iconfont iconbookmark"></i>
            燃气度数&ensp;
          </div>
          <div class="imgBody">
            <div class="imgCard">
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [contractDetail.contractImage.gas];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="contractDetail.contractImage.gas"
                />
              </div>
              <div class="text">{{ contractDetail.contract.gas }}</div>
            </div>
          </div>
        </div>
        <div>
          <div class="title">
            <i class="iconfont iconbookmark"></i>
            盖章页&ensp;
          </div>
          <div class="imgBody">
            <div class="imgCard stamp">
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [contractDetail.contractImage.stampe] || [];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="contractDetail.contractImage.stampe"
                />
              </div>
              <div class="text">{{ contractDetail.contract.stampe }}</div>
            </div>
          </div>
        </div>
        <div v-if="contractDetail.other.length > 0">
          <div class="title">
            <i class="iconfont iconbookmark"></i>
            其他&ensp;
          </div>
          <div class="imgBody">
            <div
              class="imgCard"
              v-for="(item, index) in contractDetail.other"
              :key="index"
            >
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = index;
                  images = contractDetail.other;
                "
              >
                <van-image width="3rem" height="3rem" :src="item" />
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="账单信息">
        <div
          v-for="(orderItems, index) in contractDetail.contractOrderList"
          :key="index"
        >
          <div class="orderBody">
            <div class="orderBody-body blod">
              <div class="name">{{ orderItems.orderName }}</div>
              <div :class="orderItems.status == '3' ? 'success' : 'fail'">
                {{
                  orderItems.settlementStatus
                    ? settlementStatusList[orderItems.settlementStatus - 1]
                    : payList[orderItems.status - 1]
                }}
              </div>
            </div>
            <div class="orderBody-body">
              租期：{{
                orderItems.startDate ? orderItems.startDate.slice(0, 10) : ""
              }}
              到 {{ orderItems.endDate ? orderItems.endDate.slice(0, 10) : "" }}
            </div>
            <div class="orderBody-head">
              <div>
                <p class="name">账单金额</p>
                <p class="text">￥{{ orderItems.copeAmount }}</p>
              </div>
              <div class="line"></div>
              <div>
                <p class="name">已付金额</p>
                <p class="text">￥{{ orderItems.actualAmount }}</p>
              </div>
              <div class="line"></div>
              <div>
                <p class="name">账单日期</p>
                <p class="text">
                  {{
                    orderItems.expireDate
                      ? orderItems.expireDate.slice(0, 10)
                      : ""
                  }}
                </p>
              </div>
            </div>
            <div
              :class="orderItems.detailShow ? '' : 'border-b'"
              class="orderBody-body"
            >
              <div class="name">
                <!-- <span v-if="orderItems.unpaidAmount/1<0">待收款金额</span> -->
                <span>未支付金额</span>&emsp;
                <span class="money"
                  >￥{{
                    accSub(orderItems.copeAmount, orderItems.actualAmount)
                  }}</span
                >
              </div>
              <div
                class="text"
                @click.stop="orderItems.detailShow = !orderItems.detailShow"
              >
                费用明细
                <span>
                  <i
                    v-if="!orderItems.detailShow"
                    class="iconfont iconxiala"
                  ></i>
                  <i
                    v-if="orderItems.detailShow"
                    class="iconfont iconxiangshang"
                  ></i>
                </span>
              </div>
            </div>
            <div class="details" v-if="orderItems.detailShow">
              <div
                v-for="(detail, index) in orderItems.orderItemList"
                :key="index"
              >
                <div class="name">{{ detail.matterName }}</div>
                <div>￥{{ detail.copeAmount }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="退租单">
        <div class="returnBody" v-if="contractDetail.returnOrderList.length">
          <div
            class="card"
            v-for="(item, index) in contractDetail.returnOrderList"
            :key="index"
            @click="
              $router.push({
                path: '/returnOrderDetail',
                query: { id: item.id },
              })
            "
          >
            <p>
              <span class="returnBody-title">
                <span
                  :class="{ ellipsis: !item.showTitle }"
                  @click.stop="item.showTitle = !item.showTitle"
                  >{{ item.houseAddress }}</span
                >
                | {{ item.rentType == 1 ? "合租" : "整租" }}
              </span>
            </p>
            <p>
              <span>编码：{{ item.number }}</span>
              <span class="theme-color">{{
                returnOrderStatus[item.status - 1]
              }}</span>
            </p>
            <p>
              <span>退租类型：{{ quitTypeList[item.quitType - 1] }}</span>
            </p>
            <p>
              <span>退租日期：{{ item.quitDate }}</span>
            </p>
            <p>
              <span>创建信息：{{ item.creator }} | {{ item.createDate }}</span>
            </p>
          </div>
        </div>
        <van-empty v-else description="暂无数据" />
      </van-tab>
      <van-tab title="设备信息">
        <div class="lock">
          <van-tabs
            style="margin: 0.4rem 0"
            type="card"
            v-if="deviveData && deviveData.length"
          >
            <van-tab
              v-for="(item, index) in deviveData"
              :key="index"
              :label="item.roomName"
              :title="item.roomName"
            >
              <!--   -->
              <div class="deviceList" v-if="item.deviceList.length > 0">
                <div
                  class="device active"
                  v-for="(itm, index) in item.deviceList"
                  :key="index"
                  @click="goToDeviceDetail(itm)"
                >
                  <template v-if="item.deviceList.length > 0">
                    <svg
                      width="50px"
                      height="70px"
                      fill="currentColor"
                      aria-hidden="true"
                      focusable="false"
                      class=""
                    >
                      <use
                        :xlink:href="'#' + svgSuccessList[itm.type - 1]"
                      ></use>
                    </svg>
                    <p>{{ deviceType[itm.type - 1] }}</p>
                    <!-- <h5 :class="[itm.online ? '' : 'active']">
                        {{ itm.sn }}
                      </h5> -->
                  </template>
                </div>
              </div>
              <div
                v-else
                style="text-align: center; color: #909399; padding: 20px 0"
              >
                暂无数据
              </div>
            </van-tab>
          </van-tabs>
          <van-empty v-else description="暂无数据" />
        </div>
      </van-tab>
      <!-- <van-tab title="密码记录">
        <van-list
          v-model="lockLoad"
          :finished="lockFinished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="getLockPage"
        >
          <div class="lockList" v-if="lockList.length">
            <div class="card" v-for="(item, index) in lockList" :key="index">
              <p>
                <span class="lockBody-title">
                  {{ item.startTime }}~{{ item.endTime }}
                </span>
              </p>
              <p>
                <span>密码类型：{{ lockTypeList[item.type - 1] }}</span>
                <span class="theme-color"
                  >{{ lockOpList[item.op - 1] }}｜{{
                    lockResultList[item.result - 1]
                  }}</span
                >
              </p>
              <p>
                <span>客户姓名：{{ item.name }}</span>
                <span>客户电话：{{ item.phone }}</span>
              </p>
              <p>
                <span>创建日期：{{ item.createDate }}</span>
              </p>
            </div>
          </div>
          <van-empty v-else description="暂无数据" />
        </van-list>
      </van-tab> -->
      <div style="height: 1.2rem"></div>
    </van-tabs>
    <div class="btn" v-if="!$route.query.type" style="overflow-y: hidden">
      <van-button
        type="primary"
        v-if="
          (contractDetail.contract.status == 1 ||
            contractDetail.contract.status == 3 ||
            !contractDetail.contract.status) &&
          $store.state.buttonAuth.indexOf('crm_contractChange') > -1
        "
        @click="
          contractChange();
        "
        >修改</van-button
      >
      <van-button
        type="primary"
        v-if="
          contractDetail.contract.status == 3 &&
          (contractDetail.contract.type == 1 ||
            contractDetail.contract.type == 2) &&
          $store.state.buttonAuth.indexOf('crm_contractResign') > -1
        "
        @click="contractResign()"
        >重签</van-button
      >

      <van-button
        type="primary"
        v-if="
          contractDetail.contract.status == 4 &&
          !contractDetail.contract.nextId &&
          !(endDate30 > nowDate) &&
          !(contractDetail.contract.endDate < nowDate) &&
          !(contractDetail.contract.startDate > nowDate) &&
          $store.state.buttonAuth.indexOf('crm_contractContinue') > -1
        "
        @click="
          validHZX(
            'contractAdd',
            { prevContractId: contractDetail.contract.id },
            3
          )
        "
        >续签</van-button
      >
      <van-button
        type="primary"
        v-if="
          contractDetail.contract.status == 4 &&
          !contractDetail.contract.nextId &&
          nowDate > contractDetail.contract.startDate &&
          nowDate < contractDetail.contract.endDate &&
          $store.state.buttonAuth.indexOf('crm_contractTransfer') > -1 &&
          !contractDetail.contract.activityId
        "
        @click="
          validHZX(
            'contractAdd',
            { transferContractId: contractDetail.contract.id },
            2
          )
        "
        >转租</van-button
      >
      <van-button
        type="primary"
        v-if="
          contractDetail.contract.status == 4 &&
          !contractDetail.contract.nextId &&
          nowDate > contractDetail.contract.startDate &&
          nowDate < contractDetail.contract.endDate &&
          $store.state.buttonAuth.indexOf('crm_contractChangeHouse') > -1
        "
        @click="
          validHZX(
            'contractAdd',
            { changeHouseContractId: contractDetail.contract.id },
            1
          )
        "
        >换房</van-button
      >
      <!-- <van-button
        type="primary"
        v-if="
          contractDetail.contract.status == 4 &&
          contractDetail.contract.caStatus != 3 &&
          $store.state.buttonAuth.indexOf('crm_contractCA') > -1
        "
        :loading="CALoad"
        :disabled="CALoad"
        @click="contractCA"
        >去签署(e签宝)</van-button
      > -->
      <van-button
        type="primary"
        v-if="
          contractDetail.contract.status == 4 &&
          contractDetail.contract.caStatus != 3 &&
          $store.state.buttonAuth.indexOf('crm_contractFddCA') > -1
        "
        :loading="CAFddLoad"
        :disabled="CAFddLoad"
        @click="contractFddCA"
        >去签署</van-button
      >
      <!-- <van-button
        type="primary"
        v-if="
          contractDetail.contract.caStatus == 3 &&
          $store.state.buttonAuth.indexOf('crm_contractDownload') > -1
        "
        :loading="downloadLoad"
        :disabled="downloadLoad"
        @click="contractDownload"
        >下载(e签宝)</van-button
      > -->
      <van-button
        type="primary"
        v-if="
          contractDetail.contract.caStatus == 3 &&
          $store.state.buttonAuth.indexOf('crm_contractFddDownload') > -1
        "
        :loading="downloadFddLoad"
        :disabled="downloadFddLoad"
        @click="contractDownFddload"
        >下载</van-button
      >
      <van-button
        type="primary"
        :loading="submitLoad"
        v-if="
          (contractDetail.contract.status == 1 ||
            contractDetail.contract.status == 3) &&
          $store.state.buttonAuth.indexOf('crm_contractSubmit') > -1
        "
        @click="contractSubmit"
        >提交</van-button
      >
      <van-button
        type="primary"
        v-if="
          (contractDetail.contract.status == 1 ||
            (contractDetail.contract.status == 3 &&
              !contractDetail.contract.isExistPayedOrder &&
              !(
                contractDetail.contract.status == 3 &&
                (contractDetail.contract.type == 2 ||
                  contractDetail.contract.type == 3 ||
                  contractDetail.contract.type == 4)
              ))) &&
          $store.state.buttonAuth.indexOf('crm_contractCancel') > -1
        "
        @click="
          showCancel = true;
          cancelRemark = '';
        "
        >作废</van-button
      >
      <van-button
        v-if="
          contractDetail.returnOrderButton &&
          $store.state.buttonAuth.indexOf('crm_contractReturn') > -1
        "
        type="primary"
        @click="
          validHZX(
            'returnOrderAdd',
            { contractId: contractDetail.contract.id },
            4
          )
        "
        >退租</van-button
      >
      <!-- 查看审批 -->
      <van-button
        v-if="
          contractDetail.contract.status == 9 ||
          contractDetail.contract.status == 8 ||
          contractDetail.contract.status == 5 ||
          contractDetail.contract.status == 4 ||
          contractDetail.contract.status == 3 ||
          contractDetail.contract.status == 2
        "
        type="primary"
        @click="
          $router.push({
            path: 'approval',
            query: { businessId: contractDetail.contract.id },
          })
        "
        >查看审批</van-button
      >
      <!-- 发送密码 -->

      <van-button
        v-if="
          $store.state.buttonAuth.indexOf('crm_contractSendLock') > -1 &&
          contractDetail.sendPasswordShow &&
          contractDetail.contract.status >= 2 &&
          contractDetail.contract.status <= 4
        "
        type="primary"
        @click="sendLock"
        >发送密码</van-button
      >
      <van-button
        v-if="
          $store.state.buttonAuth.indexOf('crm_contractUpStamp') > -1 &&
          contractDetail.contract.status == 4 &&
          contractDetail.contract.customerType == 2
        "
        type="primary"
        @click="upStamp"
        >上传<br />盖章页</van-button
      >
      <van-button
        v-if="
          $store.state.buttonAuth.indexOf('crm_deviceRefresh') > -1 &&
          contractDetail.eleRefreshShow &&
          (contractDetail.contract.status == 8 ||
            contractDetail.contract.status == 4 ||
            contractDetail.contract.status == 3 ||
            contractDetail.contract.status == 2)
        "
        type="primary"
        @click="deviceRefresh(contractDetail.contract)"
        >电表刷新</van-button
      >
       <van-button
        v-if="
          $store.state.buttonAuth.indexOf('crm_sendQuestion') > -1 &&
            (contractDetail.contract.status == 4 || contractDetail.contract.status == 8)

        "
        type="primary"
        @click="sendQuestion(contractDetail.contract)"
        >发送问卷</van-button
      >
    </div>
    <!-- 审批 -->
    <van-steps
      direction="vertical"
      :active="0"
      active-color="#FD7E2D"
      active-icon="more"
      inactive-icon="checked"
      v-if="type == 1"
    >
      <van-step v-for="item in trackRecordList" :key="item.id">
        <!-- 开始 -->
        <div v-if="item.taskStartEndType == 1">
          <div v-for="(item1, index1) in item.actors" :key="index1">
            <h4>{{ item1.actorName }}</h4>
            <p v-if="item.actorTime">发起时间：{{ item.actorTime }}</p>
          </div>
        </div>
        <!-- 审批 -->
        <div v-else-if="item.taskType == 1">
          <div v-for="(item1, index1) in item.actors" :key="index1">
            <h4>{{ item1.actorName }}</h4>
            <p v-if="item1.approvalStatus">
              审批结果：{{ approvalStatusList[item1.approvalStatus - 1] }}
            </p>
            <p v-if="item1.remark">审批意见：{{ item1.remark }}</p>
            <p v-if="item1.approvalTime">处理时间：{{ item1.approvalTime }}</p>
            <p v-if="item1.createTime">到达时间：{{ item1.createTime }}</p>
          </div>
        </div>
        <!-- 抄送 -->
        <div v-else-if="item.taskType == 2">
          <div>
            <h4>
              <span v-for="(item1, index1) in item.actors" :key="index1">
                <span v-if="index1 != 0">/</span>
                {{ item1.actorName }}
              </span>
            </h4>
            <p v-if="item.actors[0] ? item.actors[0].createTime : ''">
              到达时间：{{ item.actors[0] ? item.actors[0].createTime : "" }}
            </p>
          </div>
        </div>
        <!-- 结束 -->
        <div v-else>结束</div>
        <!-- <h4>
          <span v-for="(item1,index1) in item.actors" :key="index1">
            <span v-if="index1!=0">/</span>
            {{item1.actorName}}
          </span>
        </h4>
        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>-->
      </van-step>
    </van-steps>
    <van-form
      ref="form"
      label-width="110px"
      input-align="left"
      v-if="
        $route.query.type == 1 && type == 1 && trackRecordList[0].status != 5
      "
    >
      <van-field label="审批意见" :border="false" />
      <van-field
        v-model="formData.remark"
        rows="2"
        autosize
        type="textarea"
        maxlength="50"
        placeholder="请输入审批意见"
        show-word-limit
        :rules="[{ required: true, message: '请输入审批意见' }]"
      />
    </van-form>
    <div v-if="$route.query.type" style="height: 1.2rem"></div>
    <div class="btn" v-if="$route.query.type">
      <van-button v-if="type == 0" @click="type = 1" type="primary"
        >审批</van-button
      >
      <van-button v-if="type == 1" @click="type = 0" type="primary"
        >详情</van-button
      >
      <van-button
        type="primary"
        v-if="
          $route.query.type == 1 && type == 1 && trackRecordList[0].status != 5
        "
        :loading="saveLoad"
        :disabled="saveLoad"
        @click="submit(2)"
        >驳回</van-button
      >
      <van-button
        type="primary"
        v-if="
          $route.query.type == 1 && type == 1 && trackRecordList[0].status != 5
        "
        :loading="saveLoad"
        :disabled="saveLoad"
        @click="submit(1)"
        >同意</van-button
      >
    </div>
    <!-- 作废弹框 -->
    <van-dialog
      v-model="showCancel"
      title="合约作废"
      show-cancel-button
      :before-close="cancel"
    >
      <van-form ref="cancelForm">
        <div style="padding: 0.4rem; color: #323232; text-align: left">
          作废原因
        </div>
        <van-field
          v-model="cancelRemark"
          type="textarea"
          name="用户名"
          placeholder="请输入作废原因"
          rows="2"
          maxlength="50"
          autosize
          :rules="[{ required: true, message: '请填写作废原因' }]"
        />
      </van-form>
    </van-dialog>
    <!-- 资产详情 -->
    <van-dialog
      v-model="showAssets"
      title="资产详情"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
      :closeOnClickOverlay="true"
      width="300"
    >
      <van-cell title="名称" :value="asstesDetail.materialTypeName" />
      <van-cell title="品类" :value="asstesDetail.materialTypeParentName" />
      <van-cell title="规格" :value="asstesDetail.specification" />
      <van-cell title="品牌" :value="asstesDetail.brand" />
      <van-cell title="型号" :value="asstesDetail.model" />
    </van-dialog>
    <!-- 图片预览 -->
    <van-image-preview
      v-model="imgShow"
      :startPosition="imgIndex"
      :images="images"
    ></van-image-preview>
    <!-- 加载 -->
    <div class="loading" v-if="loading"></div>
    <!-- 发送密码 -->
    <van-dialog
      v-model="showSendLock"
      title="发送密码"
      show-cancel-button
      :before-close="saveLock"
      class="sendLock"
    >
      <van-form ref="lockForm" input-align="right">
        <van-field required name="type" label="密码类型">
          <template #input>
            <van-radio-group
              v-model="lockQuery.type"
              direction="horizontal"
              @change="changeLockType"
            >
              <van-radio :name="1">临时密码</van-radio>
              <van-radio :name="2">账期密码</van-radio>
              <!-- <van-radio
                v-if="
                  $store.state.buttonAuth.indexOf('crm_contractCustomLock') > -1
                "
                :name="3"
                >自定义密码</van-radio
              > -->
              <van-radio :name="4">重置密码</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!-- <van-cell title="手机号" :value="lockQuery.phone" /> -->
        <van-cell title="姓名" :value="lockQuery.name" />
        <van-field
          v-if="lockQuery.type != 1"
          :readonly="lockQuery.type != 3"
          required
          name="date"
          disabled
          :value="lockQuery.startTime"
          label="密码开始时间"
          placeholder="请选择密码开始时间"
          @click="
            (item) => {
              if (lockQuery.type == 3) {
                lockDateShowStart = true;
              }
            }
          "
          :rules="[{ required: true, message: '请选择密码开始时间' }]"
        />
        <van-field
          v-if="lockQuery.type != 1"
          readonly
          required
          name="date"
          :disabled="lockQuery.type != 3"
          :value="lockQuery.endTime"
          label="密码结束时间"
          placeholder="请选择密码结束时间"
          @click="
            (item) => {
              if (lockQuery.type == 3) {
                lockDateShowEnd = true;
              }
            }
          "
          :rules="[{ required: true, message: '请选择密码结束时间' }]"
        />
        <!-- <van-cell title="门锁在线">
          <template #default>
            <div :class="lockInfo.online == 1 ? 'success' : 'fail'">
              {{ lockInfo.online == 1 ? "在线" : "离线" }}
              <van-button
                icon="replay"
                type="info"
                size="mini"
                plain
                round
                @click="refreshLock"
              />
            </div>
          </template>
        </van-cell>
        <van-cell
          title="门锁最后在线时间"
          :value="lockInfo.displayOnlineTime"
        />
        <van-cell title="网关在线">
          <template #default>
            <div :class="lockInfo.gatewayOnline == 1 ? 'success' : 'fail'">
              {{ lockInfo.gatewayOnline == 1 ? "在线" : "离线" }}
              <van-button
                icon="replay"
                type="info"
                size="mini"
                plain
                round
                @click="refreshLock"
              />
            </div>
          </template>
        </van-cell>
        <van-cell
          title="网关最后在线时间"
          :value="lockInfo.displayGatewayOnlineTime"
        /> -->
      </van-form>
    </van-dialog>
    <!-- 门锁开始日期 -->
    <van-popup v-model="lockDateShowStart" position="bottom">
      <van-datetime-picker
        v-model="currentStartDate"
        type="datetime"
        @confirm="lockStartDateConfirm"
        @cancel="lockDateShowStart = false"
        :min-date="lockStartDateMin"
        :max-date="lockStartDateMax"
      />
    </van-popup>
    <!-- 门锁结束日期 -->
    <van-popup v-model="lockDateShowEnd" position="bottom">
      <van-datetime-picker
        v-model="currentEndDate"
        type="datetime"
        @confirm="lockEndDateConfirm"
        @cancel="lockDateShowEnd = false"
        :min-date="lockEndDateMin"
        :max-date="lockEndDateMax"
      />
    </van-popup>
    <van-dialog
      v-model="showStamp"
      title="上传盖章页"
      show-cancel-button
      @confirm="saveStamp"
      :closeOnClickOverlay="true"
      width="300"
    >
      <div style="padding: 0.5rem 0">
        <van-uploader
          :before-read="beforeRead"
          :before-delete="
            () => {
              stampUrl = [];
            }
          "
          :after-read="
            (item) => {
              stampUrl.pop();
              stampUrl.push({
                url: upload_qiniu_addr + item.file.key,
                isImage: true,
              });
            }
          "
          v-model="stampUrl"
          :max-count="1"
        />
      </div>
    </van-dialog>
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
    <!-- 问卷发送 -->
      <van-dialog
      v-model="showQuestion"
      title="发送密码"
      show-cancel-button
      :before-close="saveQuestion"
      class="sendLock"
    >
      <van-form ref="questionForm" input-align="right">
        <van-field required name="type" label="问卷类型"   :rules="[{ required: true, message: '请选择问卷类型' }]">
          <template #input>
            <van-radio-group
              v-model="questionQuery.type"
             
              direction="horizontal"
              @change="changeQuestionType"
            >
              <van-radio :name="1">初体验</van-radio>
              <van-radio :name="2">长期体验</van-radio>
              <van-radio :name="3">退租关怀</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!-- <van-cell title="手机号" :value="lockQuery.phone" /> -->
       
       <van-field
          
          readonly
          required
          name="questionCompanyId"
         
          :value="questionText"
          label="问卷模板"
          placeholder="请选择问卷模板"
          @click="
            (item) => {
               quesitonListShow = true;
             
            }
          "
          :rules="[{ required: true, message: '请选择问卷模板' }]"
        />
       
      </van-form>
    </van-dialog>

        <!-- 问卷模板 -->
    <van-popup v-model="quesitonListShow" position="bottom">
      <van-picker
       show-toolbar
      value-key="title"
        :columns="questionList"
        @confirm="questionListConfirm"
        @cancel="questionListCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import * as dd from "dingtalk-jsapi"; //钉钉
import { imgUp, imgMaskUrl, isAddTextMask } from "@/common/js/constant.js";

import {
  requestContractDetail,
  requestContractCancel,
  requestContractSubmit,
  requestWorkflowDetail1,
  requestWorkflowSubmit,
  requestCValidHZX,
  requestContractCA,
  requestContractFddCA,
  requestContractDownload,
  requestContractDownloadDD,
  requestContractFddDownload,
  requestDDConfig,
  requestLockPassword,
  requestLockKeytime,
  requestLockInfo,
  requestLockRefresh,
  requestLockPage,
  changeCompany, //钉钉消息进入详情页需切换公司 获取对应按钮权限
  requestButtomAuth,
  requestUploadStamp,
  requestQiniuToken,
  requestValidSignCheck,
  requestHouseWaterExist,
  requestHouseElectronicExist,
  requestHouseWaterIsRight,
  requestHouseElectronicIsRight,
  requestHouseSettlement, //校验房源当天有没有结算水电费
  requestGoSettlement,
  requestHouseDeviceIsOnOff,
  requsetDeviceListDetailContract,
  requestEleRefresh,
  requestContractQuestionList,
  requestContractQuestionSave
} from "@/api";
import { mergeRowCol, accSub, formatDate, parseTime } from "@/utils/index";
import Svge from "@/components/svge";
import { compress, compressAccurately } from "image-conversion";
import request from "@/utils/request";
export default {
  name: "contractDetail",
  data() {
    return {
      imgMaskUrl,
      isAddTextMask,
      showShare: false,
      options: [
        { name: "查看审批", icon: "link" },
        { name: "上传盖章页", icon: "poster" },
      ],
      active: 0,
      nowDate: "",
      endDate30: "",
      nowDate1: "",
      asstesDetail: {},
      showAssets: false,
      contractDetail: {
        assets: [], // 资产
        contractAssetsVOList: [], //资产
        community: {}, // 小区
        contract: { status: "" }, // 合约
        contractImage: {}, // 合约图片
        customer: {}, // 租客
        destineContract: {}, // 预订单
        customerPersonList: [], // 入住人
        contractOrderList: [], // 租客账单
        house: {}, // 房源
        propertyContract: {}, // 业主合约
        store: {},
        room: {}, // 房间
        orderList: [], // 账单
        periodMatterList: [], // 周期性费用
        singleMatterList: [], // 一次性费用
        other: [], //其他图片
        returnOrderList: [], //退租单
      },
      PhoneList: [
        "iPhone X",
        "iPhone 12",
        "iPhone 11",
        "iPhone 13",
        "iPhone 13P",
        "iPhone XR",
        "iPhone14,2",
      ],
      showCancel: false,
      cancelRemark: "", //作废原因
      imgShow: false,
      imgIndex: 0,
      images: [],
      //审批
      type: 0, //切换0.详情/1.审批
      saveLoad: false,
      CALoad: false,
       CAFddLoad: false,
      downloadLoad: false,
        downloadFddLoad: false,
      trackRecordList: [{ status: "" }],
      processTypeList: ["", "收房合约", "租房合约", "收房退租", "租房退租"],
      statusList: ["", "审批中", "已完成", "取消", "挂起"],
      loading: true,
      formData: {
        remark: "",
      },
      //发送密码
      showSendLock: false,
      lockDateShowStart: false,
      lockStartDateMin: new Date(2010, 0, 1),
      lockStartDateMax: new Date(2025, 10, 1),
      currentStartDate: new Date(),
      lockDateShowEnd: false,
      lockEndDateMin: new Date(2010, 0, 1),
      lockEndDateMax: new Date(2025, 10, 1),
      currentEndDate: new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      ),
      lockInfo: {},
      lockQuery: {
        type: 1,
        phone: "",
        houseId: "",
        custom: true, //true 自定义密码
        contractId: "", //合约ID
        startTime: "",
        endTime: "",
      },
      saveLoadLock: false,
      lockLoad: false,
      lockFinished: false,
      lockPageQuery: {
        houseId: "",
        contractId: "",
        pageNumber: 1,
        pageSize: 10,
      },
      lockList: [],
      qiniuData: {
        token: "",
        key: "",
      },
      showStamp: false,
      stampUrl: [],
      stampQuery: {
        contractId: "",
        stampe: "",
      },
      showWaterModel: "",
      showElectronicModel: "",
      waterSubmit: "",
      ElectronicSubmit: "",
      submitLoad: false,
      deviceLoading: false,
      deviveData: [],
      // 问卷发送
      showQuestion:false,
    questionQuery:{
     type: "",
        questionCompanyId: "",
    },
    quesitonListShow:false,
    questionList:[],
    questionText:"",
    };
  },
  computed: {
    ...mapState([
      "idTypeList",
      "destineList",
      "payList",
      "settlementStatusList",
      "contractList",
      "CAStatusList",
      "customerList",
      "contactList",
      "quitTypeList",
      "contractTypeList",
      "returnOrderStatus",
      "approvalStatusList",
      "lockTypeList",
      "lockStatusList",
      "lockResultList",
      "lockOpList",
      "upload_qiniu_addr",
      "syncFgjNjList",
      "caStatusList",
      "deviceTypeIcon",
      "deviceType",
      "svgSuccessList",
      "svgFailList",
    ]),
  },
  components: {
    Svge,
  },
  created() {
    console.log(this.$store.state.buttonAuth.indexOf("crm_contractChange"));
    this.nowDate = parseTime(new Date());
    this.nowDate1 = parseTime(
      new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
    );
    this.getDetail();
    if (this.$route.query.type) {
      //待办/抄送
      this.getWorkflow();
    }
    // this.$global.url = window.location.href;
  },
  mounted() {
    this.getQiniuToken();
  },
  methods: {
    getQiniuToken() {
      requestQiniuToken()
        .then((res) => {
          this.qiniuData.token = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSelect() {},
    upStamp() {
      requestContractDetail(this.$route.query.id).then((res) => {
        this.stampUrl = res.data.contractImage.stampe
          ? [
              {
                url: res.data.contractImage.stampe,
                isImage: true,
              },
            ]
          : [];
        this.showStamp = true;
      });
    },
    saveStamp() {
      console.log(this.stampUrl);
      this.showStamp = true;
      this.stampQuery.stampe =
        this.stampUrl.length > 0 ? this.stampUrl[0].url : "";
      this.stampQuery.contractId = this.contractDetail.id;
      // console.log(this.stampQuery)
      requestUploadStamp(this.stampQuery).then((res) => {
        // console.log(res)

        if (!res.data) {
          this.$toast.success({
            message: "操作成功",
            onClose: () => {
              this.showStamp = false;
              this.getDetail();
            },
          });
        }
      });
    },
    //图片上传前校验，压缩
    beforeRead(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isLt8M = file.size / 1024 / 1024 < 8;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG) {
        this.$toast.fail("图片只能是 JPG/PNG 格式！");
        return false;
      }
      if (!isLt10M) {
        this.$toast.fail("图片大小不能超过 10MB!");
        return false;
      }
      this.qiniuData.key = Date.now() + file.name;
      return new Promise((resolve, reject) => {
        compressAccurately(file, 400).then((fileMin) => {
          let data = new FormData();
          data.append("token", this.qiniuData.token);
          data.append("key", this.qiniuData.key);
          data.append("file", fileMin);
          request({
            url: this.$store.state.qiniuUpload,
            method: "post",
            processData: false,
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: data,
          })
            .then((res) => {
              let newFile = fileMin;
              newFile.key = res.key;
              resolve(newFile);
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        });
      });
    },
    getDetail() {
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requestContractDetail(this.$route.query.id)
        .then((res) => {
          res.data.orderList = res.data.orderList
            ? mergeRowCol(res.data.orderList, "orderNumber")
            : [];
          res.data.contractOrderList.forEach((d) => {
            d.detailShow = false;
          });
          res.data.returnOrderList.forEach((d) => {
            d.showTitle = false;
          });
          this.contractDetail = res.data;
          this.contractDetail.assets = res.data.assets ? res.data.assets : []; // 资产
          this.contractDetail.contractAssetsVOList = res.data
            .contractAssetsVOList
            ? res.data.contractAssetsVOList
            : []; // 资产
          this.contractDetail.community = res.data.community
            ? res.data.community
            : {}; // 小区
          this.contractDetail.contract = res.data.contract
            ? res.data.contract
            : {}; // 合约
          this.contractDetail.contractImage = res.data.contractImage
            ? res.data.contractImage
            : {}; // 合约图片
          this.contractDetail.customer = res.data.customer
            ? res.data.customer
            : {}; // 租客
          this.contractDetail.destineContract = res.data.destineContract
            ? res.data.destineContract
            : {}; // 预订单
          this.contractDetail.customerPersonList = res.data.customerPersonList
            ? res.data.customerPersonList
            : []; // 入住人
          this.contractDetail.contractOrderList = res.data.contractOrderList
            ? res.data.contractOrderList
            : []; // 租客账单
          this.contractDetail.house = res.data.house ? res.data.house : {}; // 房源
          this.contractDetail.propertyContract = res.data.propertyContract
            ? res.data.propertyContract
            : {}; // 业主合约
          this.contractDetail.store = res.data.store ? res.data.store : {};
          this.contractDetail.room = res.data.room; // 房间
          this.contractDetail.orderList = res.data.orderList
            ? res.data.orderList
            : []; // 账单
          this.contractDetail.periodMatterList = res.data.periodMatterList
            ? res.data.periodMatterList
            : []; // 周期性费用
          this.contractDetail.singleMatterList = res.data.singleMatterList
            ? res.data.singleMatterList
            : []; // 一次性费用
          this.contractDetail.other =
            res.data.contractImage && res.data.contractImage.other
              ? res.data.contractImage.other.split(";")
              : [];
          this.contractDetail.returnOrderList = res.data.returnOrderList
            ? res.data.returnOrderList
            : [];
          this.endDate30 = parseTime(
            new Date(res.data.contract.endDate.replace(/-/g, "/")).getTime() -
              30 * 24 * 60 * 60 * 1000
          );
          changeCompany({ companyId: res.data.contract.companyId }).then(
            (res) => {
              this.$store.dispatch("resetAll", res.data);
              requestButtomAuth().then((res) => {
                this.$store.commit("SET_BUTTON", res.data || []);
              });
            }
          );
          this.lockPageQuery.contractId = this.contractDetail.contract.id;
          this.lockPageQuery.houseId = this.contractDetail.house.id;
          this.getLockPage();
          this.getDeviceListDetail();
          toast1.clear();
          this.loading = false;
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    //查流程
    getWorkflow() {
      //审批待办
      requestWorkflowDetail1(this.$route.query.agentId).then((res) => {
        this.trackRecordList = res.data ? res.data : [];
        this.trackRecordList[0].status == 5 ? (this.type = 1) : (this.type = 0);
        // this.loading = false;
      });
    },
    accSub(num1, num2) {
      return accSub(num1, num2);
    },
    //资产详情
    lookAssets(assets) {
      this.asstesDetail = assets;
      this.showAssets = true;
    },
    //密码记录
    getLockPage() {
      requestLockPage(this.lockPageQuery)
        .then((res) => {
          if (this.lockFinished) return;
          this.lockList = [...this.lockList, ...res.data.records];
          let prePage = accSub(res.data.pages, 1);
          this.lockLoad = false;
          this.lockPageQuery.pageNumber++;
          if (
            (res.data.pages == res.data.current &&
              res.data.records.length ==
                accSub(res.data.total, prePage * 10)) ||
            !res.data.records.length
          ) {
            this.lockFinished = true;
          }
        })
        .catch((err) => {
          this.lockLoad = false;
          this.lockFinished = true;
        });
    },
    // 根据房源判断绑定关系是否存在 水表
    async getHouseWaterExist() {
      let checkRoom = this.contractDetail.contract.rentType - 1;
      return requestHouseWaterExist(
        this.contractDetail.contract.houseId,
        checkRoom
      )
        .then((res) => {
          this.showWaterModel = !res.data;
          return res;
        })
        .catch((err) => {});
    },
    // 根据房源判断绑定关系是否存在 电表
    async getHouseElectronicExist() {
      let checkRoom = this.contractDetail.contract.rentType - 1;
      return requestHouseElectronicExist(
        this.contractDetail.contract.houseId,
        checkRoom
      )
        .then((res) => {
          this.showElectronicModel = !res.data;
          return res;
        })
        .catch((err) => {});
    },

    // 根据房源判断绑定关系是否正确 水表
    getHouseWaterExistIsRight() {
      let checkRoom = this.contractDetail.contract.rentType - 1;
      return requestHouseWaterIsRight(
        this.contractDetail.contract.houseId,
        checkRoom
      )
        .then((res) => {
          this.waterSubmit = res.data;
          return res;
        })
        .catch((err) => {});
    },

    // 根据房源判断绑定关系是否存在 电表
    getHouseElectronicExistIsRight() {
      let checkRoom = this.contractDetail.contract.rentType - 1;
      return requestHouseElectronicIsRight(
        this.contractDetail.contract.houseId,
        checkRoom
      )
        .then((res) => {
          this.ElectronicSubmit = res.data;
          return res;
        })
        .catch((err) => {});
    },
    getHouseSettlement() {
      return new Promise((resolve, reject) => {
        requestHouseSettlement(this.contractDetail.contract.id).then((res) => {
          if (res) {
            this.goSettlement = res.data;
            resolve(res);
          }
        });
      });
    },
    getHouseIsOnOff() {
      let checkRoom = this.contractDetail.contract.rentType - 1;
      return requestHouseDeviceIsOnOff(
        this.contractDetail.contract.houseId,
        checkRoom
      ).then((res) => {
        if (res) {
          return res;
        }
      });
    },
    //提交
    async contractSubmit() {
      this.submitLoad = true;
      this.$dialog.confirm({
        title: "提示",
        message: "确认提交",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, done) => {
          if (action === "confirm") {
            requestContractSubmit(this.contractDetail.contract.id)
              .then((res) => {
                done();
                this.submitLoad = false;
                this.$toast({
                  type: "success",
                  message: "提交成功!",
                  // forbidClick: true,
                  onClose: () => {},
                });
                this.getDetail();
              })
              .catch((err) => {
                this.submitLoad = false;
                done(false);
              });
          } else {
            this.submitLoad = false;
            done();
          }
        },
      });
    },
    isToday(date) {
      return moment(moment().locale("zh-cn").format("YYYY-MM-DD")).isSame(date); // true
    },
    //换转续校验退租单，账单支付
    validHZX(url, query, type) {
      const day = this.contractDetail.contract.startDate.split(" ");
      const result = this.isToday(day[0]);
      requestCValidHZX(this.contractDetail.contract.id, type).then((res) => {
        if ((type == 2 || type == 1) && result) {
          this.$toast.fail("当前合约不在有效期内!");
        } else {
          this.$router.push({ path: url, query: query });
        }
      });
    },
    // 修改合约
    contractChange(){
         requestContractDetail(this.$route.query.id)
        .then((res) => {
          if (res.data.contract.status == 1 || res.data.contract.status == 3) {
             this.$router.push({
                path: 'contractAdd',
                query: {
                  contractId: this.contractDetail.contract.id,
                  ownerType: this.contractDetail.tenantType,
                },
              });
          } else {
             this.$toast.fail("只有保存或打回的状态才能修改，请检查合约最新状态");
            return false;
          }
        })
        .catch((err) => {});
    },
    // 重签合约按钮
    contractResign() {
      requestContractDetail(this.$route.query.id)
        .then((res) => {
          if ( res.data.contract.status == 3) {
              this.$router.push({
                  path: 'contractAdd',
                  query: { oldContractId: this.contractDetail.contract.id },
                })
          } else {
            
             this.$toast.fail("只有打回的状态才能重签，请检查合约最新状态");
           
            return false;
          }
        })
        .catch((err) => {});
    },
    //CA
    contractCA() {
      this.CALoad = true;
      // var winRef = window.open();
      // requestValidSignCheck(this.contractDetail.contract.id).then((res) => {
      //   if (res.data) {
      //     this.$toast.fail(
      //       "该客户未进行“宁慧租”刷脸认证，请提示客户到个人中心-我的合约-合约详情进行刷脸操作"
      //     );
      //     this.CALoad = false;
      //   } else {
      //     requestContractCA(this.contractDetail.contract.id)
      //       .then((res) => {
      //         this.CALoad = false;
      //         this.$toast.success("电子合约签署短信已发送到租客手机！");
      //         // window.open(res.data);
      //       })
      //       .catch((err) => {
      //         this.CALoad = false;
      //       });
      //   }
      // });
      requestContractCA(this.contractDetail.contract.id)
        .then((res) => {
          if (res) {
            this.$toast.success("电子合约签署短信已发送到租客手机！");
            this.CALoad = false;
          }

          // window.location.href = res.data;
          // winRef.location = res.data
        })
        .catch((err) => {
          this.CALoad = false;
        });
    },
     //CA
    contractFddCA() {
      this.CAFddLoad = true;
      // var winRef = window.open();
      // requestValidSignCheck(this.contractDetail.contract.id).then((res) => {
      //   if (res.data) {
      //     this.$toast.fail(
      //       "该客户未进行“宁慧租”刷脸认证，请提示客户到个人中心-我的合约-合约详情进行刷脸操作"
      //     );
      //     this.CALoad = false;
      //   } else {
      //     requestContractCA(this.contractDetail.contract.id)
      //       .then((res) => {
      //         this.CALoad = false;
      //         this.$toast.success("电子合约签署短信已发送到租客手机！");
      //         // window.open(res.data);
      //       })
      //       .catch((err) => {
      //         this.CALoad = false;
      //       });
      //   }
      // });
      requestContractFddCA(this.contractDetail.contract.id)
        .then((res) => {
          if (res) {
            this.$toast.success("电子合约签署短信已发送到租客手机！");
            this.CAFddLoad = false;
          }

          // window.location.href = res.data;
          // winRef.location = res.data
        })
        .catch((err) => {
          this.CAFddLoad = false;
        });
    },
    // 获取手机型号
    getMobile() {
      return new Promise(function (reslove, reject) {
        dd.device.base.getPhoneInfo({
          onSuccess: (data) => {
            //   alert(JSON.stringify(data))
            reslove(data);
          },
          onFail: (err) => {
            reject(err);
          },
        });
      });
    },
    //获取钉钉授权
    getDDconfig() {
      return this.getMobile().then((data) => {
        console.log(dd.env.platform);
        if (dd.env.platform == "ios") {
          this.$toast(`${data.model}`);
          if (this.PhoneList.indexOf(data.model) > -1) {
            return new Promise((resolve, reject) => {
              requestDDConfig({
                url: window.location.origin + "/",
              })
                .then((res) => {
                  resolve(res.data);
                })
                .catch((err) => {
                  reject(err);
                });
            });
          } else {
            return new Promise((resolve, reject) => {
              requestDDConfig({
                url: this.$global.url,
              })
                .then((res) => {
                  //   alert(JSON.stringify(res.data));
                  resolve(res.data);
                })
                .catch((err) => {
                  reject(err);
                });
            });
          }
        } else {
          return new Promise((resolve, reject) => {
            requestDDConfig({
              url: this.$global.url,
            })
              .then((res) => {
                // alert(JSON.stringify(res.data));
                resolve(res.data);
              })
              .catch((err) => {
                reject(err);
              });
          });
        }
      });
    },
    copyShaneUrl(shareLink) {
      // var input = document.createElement("input");   // 直接构建input
      // input.value = shareLink;  // 设置内容
      // document.body.appendChild(input);    // 添加临时实例
      // input.select();   // 选择实例内容
      // document.execCommand("Copy");   // 执行复制
      // document.body.removeChild(input); // 删除临时实例

      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        const range = document.createRange();
        range.selectNode(
          document.getElementsByClassName("van-dialog__message")[0]
        );
        const selection = window.getSelection();
        if (selection.rangeCount > 0) selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand("copy");
        // alert("复制成功")
      } else {
        var input = document.createElement("input"); // 直接构建input
        input.value = shareLink; // 设置内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
      }
    },
    //下载
    contractDownload() {
      this.downloadLoad = true;
      requestContractDownload(this.contractDetail.contract.id)
        .then(async (res) => {
          console.log(res);
          this.$dialog
            .alert({
              title: "请复制内容在浏览器打开",
              message: `${res.data}`,
              confirmButtonText: "复制",
            })
            .then(() => {
              this.copyShaneUrl(res.data);
              this.$toast.success("复制成功");
              this.downloadLoad = false;
            });
          // if (dd.env.platform !== "notInDingTalk") {
          //   const _config = await this.getDDconfig();
          //   dd.config({
          //     agentId: _config["agentId"],
          //     corpId: _config["corpId"],
          //     timeStamp: _config["timeStamp"],
          //     nonceStr: _config["nonceStr"],
          //     signature: _config["signature"],
          //     jsApiList: [
          //       //需要调用的接口列表
          //       "biz.cspace.saveFile",
          //     ],
          //   });
          //   this.downloadLoad = false;
          //   let name =
          //     this.contractDetail.customer.name +
          //     this.contractDetail.contract.number +
          //     "合约";
          //    this.$toast.success(`${res.data}`);
          //   dd.ready(function () {
          //     dd.biz.cspace.saveFile({
          //       corpId: _config.corpId,
          //       url: res.data, // 文件在第三方服务器地址， 也可为通过服务端接口上传文件得到的media_id，详见参数说明
          //       name: name,
          //       onSuccess: function (data) {
          //       //   alert(JSON.stringify(data));
          //         this.$toast.success("文件已保存至钉盘");
          //       },
          //       onFail: function (err) {
          //         console.log(err);
          //       //   alert(JSON.stringify(err));
          //       },
          //     });
          //   });
          //   dd.error(function (err) {
          //     console.log(JSON.stringify(err));
          //   //   alert("dd error: " + JSON.stringify(err));
          //   });
          // } else {
          //   this.downloadLoad = false;
          //   window.location.href = res.data;
          // }
          // winRef.location = res.data
        })
        .catch((err) => {
          this.downloadLoad = false;
        });
    },
     //fadada下载
    contractDownFddload() {
      this.downloadFddLoad = true;
      requestContractFddDownload(this.contractDetail.contract.id)
        .then(async (res) => {
          console.log(res);
          this.$dialog
            .alert({
              title: "请复制内容在浏览器打开",
              message: `${res.data}`,
              confirmButtonText: "复制",
            })
            .then(() => {
              this.copyShaneUrl(res.data);
              this.$toast.success("复制成功");
              this.downloadFddLoad = false;
            });
          // if (dd.env.platform !== "notInDingTalk") {
          //   const _config = await this.getDDconfig();
          //   dd.config({
          //     agentId: _config["agentId"],
          //     corpId: _config["corpId"],
          //     timeStamp: _config["timeStamp"],
          //     nonceStr: _config["nonceStr"],
          //     signature: _config["signature"],
          //     jsApiList: [
          //       //需要调用的接口列表
          //       "biz.cspace.saveFile",
          //     ],
          //   });
          //   this.downloadLoad = false;
          //   let name =
          //     this.contractDetail.customer.name +
          //     this.contractDetail.contract.number +
          //     "合约";
          //    this.$toast.success(`${res.data}`);
          //   dd.ready(function () {
          //     dd.biz.cspace.saveFile({
          //       corpId: _config.corpId,
          //       url: res.data, // 文件在第三方服务器地址， 也可为通过服务端接口上传文件得到的media_id，详见参数说明
          //       name: name,
          //       onSuccess: function (data) {
          //       //   alert(JSON.stringify(data));
          //         this.$toast.success("文件已保存至钉盘");
          //       },
          //       onFail: function (err) {
          //         console.log(err);
          //       //   alert(JSON.stringify(err));
          //       },
          //     });
          //   });
          //   dd.error(function (err) {
          //     console.log(JSON.stringify(err));
          //   //   alert("dd error: " + JSON.stringify(err));
          //   });
          // } else {
          //   this.downloadLoad = false;
          //   window.location.href = res.data;
          // }
          // winRef.location = res.data
        })
        .catch((err) => {
          this.downloadLoad = false;
        });
    },
    //作废
    cancel(action, done) {
      if (action === "confirm") {
        this.$refs.cancelForm
          .validate()
          .then((valid) => {
            requestContractCancel(this.contractDetail.contract.id, {
              cancelRemark: this.cancelRemark,
            })
              .then((res) => {
                this.$toast({
                  type: "success",
                  message: "作废成功!",
                  // forbidClick: true,
                  onClose: () => {},
                });
                this.getDetail();
                done();
              })
              .catch((err) => {
                console.log(err);
                done(false);
              });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        done();
      }
    },
    //审批提交
    submit(type) {
      let param = {
        agentId: this.$route.query.agentId,
        orderId: this.$route.query.orderId,
        approvalStatus: type,
        remark: this.formData.remark,
      };
      if (type == 1) {
        //同意
        this.$dialog.confirm({
          title: "提示",
          message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, done) => {
            if (action === "confirm") {
              this.saveLoad = true;
              requestWorkflowSubmit(param)
                .then((res) => {
                  this.$toast({
                    type: "success",
                    message: "审批成功!",
                    // forbidClick: true,
                    onClose: () => {},
                  });
                  this.getWorkflow();
                  this.saveLoad = false;
                  done();
                })
                .catch((err) => {
                  this.saveLoad = false;
                  done(false);
                });
            } else {
              done();
            }
          },
        });
      } else {
        //驳回
        this.$refs["form"].validate().then((valid) => {
          this.$dialog.confirm({
            title: "提示",
            message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            beforeClose: (action, done) => {
              if (action === "confirm") {
                this.saveLoad = true;
                requestWorkflowSubmit(param)
                  .then((res) => {
                    this.$toast({
                      type: "success",
                      message: "审批成功!",
                      // forbidClick: true,
                      onClose: () => {},
                    });
                    this.getWorkflow();
                    this.saveLoad = false;
                    done();
                  })
                  .catch((err) => {
                    this.saveLoad = false;
                    done(false);
                  });
              } else {
                done();
              }
            },
          });
        });
      }
    },
    //发送密码
    sendLock() {
      this.showSendLock = true;
      this.lockQuery.houseId = this.contractDetail.house.id;
      this.lockQuery.contractId = this.contractDetail.id;
      this.lockQuery.phone = this.contractDetail.customer.phone;
      this.lockQuery.name = this.contractDetail.customer.name;
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requestLockInfo(this.contractDetail.house.id)
        .then((res) => {
          this.lockInfo = res.data || {};
          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    deviceRefresh(row) {
      requestEleRefresh(row.id)
        .then((res) => {
          if (!res.data) {
            this.$toast.success({
              message: "电表刷新成功",
            });
          }
        })
        .catch((err) => {});
    },
    changeLockType() {
      this.lockQuery.startTime = "";
      this.lockQuery.endTime = "";
      if (this.lockQuery.type == 2 || this.lockQuery.type == 4) {
        //周期密码||重置密码
        requestLockKeytime(this.lockQuery.contractId).then((res) => {
          this.lockQuery.startTime = res.data.startTime;
          this.lockQuery.endTime = res.data.endTime;
        });
      }
    },
    lockStartDateConfirm(e) {
      this.lockQuery.startTime = parseTime(e);
      this.lockEndDateMin = e;
      this.lockDateShowStart = false;
    },
    lockEndDateConfirm(e) {
      this.lockQuery.endTime = parseTime(e);
      console.log(this.lockQuery);
      this.lockStartDateMax = e;
      this.lockDateShowEnd = false;
    },
    getDeviceListDetail() {
      this.deviceLoading = true;
      requsetDeviceListDetailContract(this.contractDetail.contract.id)
        .then((res) => {
          console.log(res);
          this.deviceLoading = false;
          this.deviveData = res.data;
        })
        .catch((err) => {
          this.deviceLoading = false;
          console.log(err);
        });
    },
    goToDeviceDetail(row) {
      this.$router.push({ path: "/deviceDetail", query: { id: row.id } });
    },
    //门锁刷新
    refreshLock() {
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requestLockRefresh(this.lockQuery.houseId)
        .then((res) => {
          this.lockInfo = res.data || {};

          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    saveLock(action, done) {
      if (action === "confirm") {
        this.$refs.lockForm
          .validate()
          .then((valid) => {
            if (this.lockQuery.type == 1) {
              //临时密码
              let param = {
                phone: this.lockQuery.phone,
                houseId: this.lockQuery.houseId,
                type: 1,
                contractId: this.lockQuery.contractId,
              };
              requestLockPassword(param)
                .then((res) => {
                  done();
                  this.$toast({
                    type: "success",
                    message: "发送成功!",
                    overlay: true,
                    closeOnClickOverlay: true,
                    onClose: () => {
                      this.getDetail();
                      this.lockLoad = false;
                      this.lockFinished = false;
                      this.lockPageQuery.pageNumber = 1;
                      this.lockList = [];
                      this.getLockPage();
                    },
                  });
                  this.showSendLock = false;
                })
                .catch((err) => {
                  done(false);
                });
            } else {
              let param = {
                custom: this.lockQuery.type == 3, //true 自定义密码
                contractId: this.lockQuery.contractId, //合约ID
                startTime: this.lockQuery.startTime, //自定义密码时，起止时间必选可选，账期密码调用接口（5）获取起止时间显示，不可修改
                endTime: this.lockQuery.endTime,
                type: this.lockQuery.type,
              };
              requestLockPassword(param)
                .then((res) => {
                  done();
                  this.$toast({
                    type: "success",
                    message: "发送成功!",
                    overlay: true,
                    closeOnClickOverlay: true,
                    onClose: () => {
                      this.getDetail();
                      this.lockLoad = false;
                      this.lockFinished = false;
                      this.lockPageQuery.pageNumber = 1;
                      this.lockList = [];
                      this.getLockPage();
                    },
                  });
                  this.showSendLock = false;
                })
                .catch((err) => {
                  done(false);
                });
            }
          })
          .catch((err) => {
            done(false);
          });
      } else {
        done();
        this.resetLock();
      }
    },
    sendQuestion(row){
        this.showQuestion= true
        this.questionList = [];
    },
    saveQuestion(action, done) {
      if (action === "confirm") {
        this.$refs.questionForm
          .validate()
          .then((valid) => {
            console.log(this.questionQuery)
          this.questionQuery.contractId = this.contractDetail.contract.id;
         requestContractQuestionSave(this.questionQuery)
                .then((res) => {
                  done();
                  this.$toast({
                    type: "success",
                    message: "发送成功!",
                    overlay: true,
                    closeOnClickOverlay: true,
                    onClose: () => {
                      this.getDetail();
                      this.resetQuestion();
                    },
                  });
                  this.showSendLock = false;
                })
                .catch((err) => {
                  done(false);
                });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        console.log("cancel")
        done();
        this.resetQuestion();
      }
    },
    changeQuestionType(){
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
       this.questionList = [];
       this.questionText=""
      this.questionQuery.questionCompanyId = "";
       requestContractQuestionList(this.questionQuery.type)
        .then((res) => {
            this.questionList = res.data;

          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    questionListConfirm(item ) {
      this.questionText = item.title
     this.questionQuery.questionCompanyId = item.id
      this.quesitonListShow = false;
    },
     questionListCancel(item ) {
     
      this.quesitonListShow = false;
    },
    resetLock() {
      this.lockStartDateMax = new Date(2025, 10, 1);
      this.lockEndDateMin = new Date(2010, 0, 1);
      this.lockInfo = {};
      this.lockQuery = {
        type: 0,
        phone: "",
        houseId: "",
        custom: "", //true 自定义密码
        contractId: "", //合约ID
        startTime: "",
        endTime: "",
      };
    },
     resetQuestion() {
     
      this.questionList = [];
      this.questionText=""
      this.questionQuery = {
        type: '',
        questionCompanyId:""
      };
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";

.noData {
  line-height: 1rem;
}
.theme-color {
  color: $theme-color;
}
.tabs {
  .title {
    text-align: left;
    padding: 0.3rem 0.2rem;
    font-weight: 600;
    font-size: 0.37rem;
  }
  /deep/.van-tabs__wrap {
    // margin: 0.2rem 0;
  }
  /deep/.van-tab {
    // flex: 1;
    padding: 0 0.15rem;
  }
  /deep/.van-tabs__content {
    height: calc(100vh - 1.2rem);
    overflow: scroll;
  }
  /deep/.van-tabs__nav--card {
    border: 0.02667rem solid #fd7e2d;
  }
  /deep/.van-tabs__nav--card .van-tab.van-tab--active {
    background-color: #fd7e2d;
    color: #fff;
  }
  /deep/.van-tabs__nav--card .van-tab {
    color: #333;
    border-right: 0.02667rem solid #fd7e2d;
  }
  /deep/.van-tabs__nav--card .van-tab:last-child {
    border-right: none;
  }
  .assets {
    .title {
      background-color: #fff;
    }
    .assetsBody {
      display: flex;
      justify-content: flex-start;
      background-color: #fff;
      padding: 0.2rem 0;
      flex-wrap: wrap;
      > div {
        width: 28%;
        height: 0.8rem;
        line-height: 0.8rem;
        border: 1px solid $theme-color;
        color: $theme-color;
        text-align: center;
        margin: 0 2.5% 0.1rem;
      }
    }
  }
  .orderBody {
    padding: 0 0.2rem;
    // border: 2px dashed #dadada;
    margin: 0.4rem 0;
    border-radius: 0.2rem;
    background-color: #fff;
    .orderBody-head {
      padding: 0.2rem;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid $border-color;
      .line {
        width: 1px;
        height: 0.8rem;
        transform: translateY(0.05rem);
        background: #dadada;
      }
      .name {
      }
      .text {
        font-weight: bold;
        // color: $font-deep-gray;
      }
      p {
        padding: 0.1rem 0;
      }
    }
    .orderBody-body {
      display: flex;
      padding: 0.3rem 0;
      border-bottom: 1px solid $border-color;
      .name {
        flex: 1;
        text-align: left;
        .money {
          color: $fail-color;
        }
      }

      .pay {
        color: #fff;
        padding: 0.1rem 0.2rem;
        background: #fd7e2d;
        border-radius: 0.1rem;
      }
      .text {
        span {
          display: inline-block;
          width: 0.5rem;
        }
        i {
          font-size: 0.3rem;
        }
      }
    }
    .border-b {
      border: none !important;
    }
    .details {
      color: $font-deep-gray;
      padding: 0.2rem 0;
      > div {
        display: flex;
        padding: 0.1rem;
        .name {
          flex: 1;
          text-align: left;
        }
      }
    }
    .blod {
      font-weight: bold;
    }
  }
  .imgBody {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    background-color: #fff;
    padding: 0.5rem 0.2rem 0;
    border-radius: 0.2rem;
    .imgCard {
      margin: 0 0.1rem;

      &.stamp {
        margin: 0 0.1rem 0.5rem;
      }
      .text {
        line-height: 0.8rem;
      }
    }
  }
  .imgBody1 {
    padding: 0 0.2rem;
  }
  .returnBody {
    // padding-top: 0.001rem;
    font-size: 0.35rem;
    margin-top: 0.3rem;
    .card {
      background: #fff;
      margin: 0.3rem;
      border-radius: 0.2rem;
      color: $color9;
      padding: 0.2rem 0;
      // margin: 0.2rem 0;
      p {
        text-align: left;
        display: flex;
        justify-content: space-between;
        padding: 0 0.4rem;
        line-height: 0.8rem;
        > span {
          height: 0.8rem;
        }
        .returnBody-title {
          font-size: 0.35rem;
          font-weight: 600;
          height: auto;
          color: #000;
          // span {
          //     max-width: 4.5rem;
          //     vertical-align: top;
          //     overflow: hidden;
          //     display: inline-block;
          //     height: auto;
          //     text-overflow: ellipsis;
          // }
          // .ellipsis {
          //     white-space: nowrap;
          // }
        }
        .big {
          font-size: 0.4rem;
        }
      }
    }
    > .card:first-child {
      margin-top: 0;
    }
    .theme-color {
      color: $theme-color;
    }
  }
  .lockList {
    // padding-top: 0.001rem;
    font-size: 0.35rem;
    margin-top: 0.3rem;
    .card {
      background: #fff;
      margin: 0.3rem;
      border-radius: 0.2rem;
      color: $color9;
      padding: 0.2rem 0;
      // margin: 0.2rem 0;
      p {
        text-align: left;
        display: flex;
        justify-content: space-between;
        padding: 0 0.4rem;
        line-height: 0.8rem;
        > span {
          height: 0.8rem;
        }
        .lockBody-title {
          font-size: 0.35rem;
          font-weight: 600;
          height: auto;
          color: #000;
          // span {
          //     max-width: 4.5rem;
          //     vertical-align: top;
          //     overflow: hidden;
          //     display: inline-block;
          //     height: auto;
          //     text-overflow: ellipsis;
          // }
          // .ellipsis {
          //     white-space: nowrap;
          // }
        }
        .big {
          font-size: 0.4rem;
        }
      }
    }
    > .card:first-child {
      margin-top: 0;
    }
    .theme-color {
      color: $theme-color;
    }
  }
}
.btn {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 0.1rem;
  //   overflow-x: auto;
  // overflow-y: hidden;
  display: flex;
  /deep/.van-button {
    // flex: 1 0 auto;
    margin-left: -1px;
    border: none;
    border-radius: 0;
    flex: 1;
    &:not(:last-child)::after {
      height: 50%;
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      border-right: 0.02667rem solid #ebedf0;
      z-index: 99;
    }
  }
}
.sendLock {
  .van-radio-group--horizontal {
    justify-content: space-between;
  }
}
.van-steps {
  text-align: left;
  padding-left: 2rem;
  /deep/.van-step__title {
    padding-left: 0.3rem;
    p {
      padding-top: 0.2rem;
    }
  }
}
.success {
  color: $success-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
.fail {
  color: $fail-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
/deep/.van-uploader__preview-image,
/deep/ .van-uploader__upload,
/deep/.van-uploader__file {
  width: 4rem;
  height: 4rem;
}
/deep/.van-button--normal {
  padding: 0 0.2rem;
  font-size: 0.32rem;
}
.deviceList {
  padding: 0 20px 20px 20px;
  display: flex;
  flex-wrap: wrap;
  .device {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin-bottom:20px;
    .iconfont {
      margin: 20px 0 10px 0;
      font-size: 64px;
      &.active {
        color: #cccccc;
      }
    }
    &.active {
      cursor: pointer;
    }
    p {
      font-size: 12px;
      color: #05bac5;
      margin-bottom: 15px;
      &.active {
        color: #cccccc;
      }
    }
    h5 {
      color: #05bac5;
      &.active {
        color: #cccccc;
      }
    }
  }
}
</style>
